import {Component, ChangeDetectionStrategy} from "@angular/core";

@Component({
  selector: "sbb-card-grid",
  templateUrl: "./card-grid.component.html",
  styleUrls: ["./card-grid.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CardGridComponent {}
